import { lazy, Suspense } from "react";
import { Navbar } from "@/components/garage/Navbar";
import { Hero } from "@/components/garage/Hero";
import { HowItWorks } from "@/components/garage/HowItWorks";
import { LaunchOffer } from "@/components/garage/LaunchOffer";
import { Services } from "@/components/garage/Services";
import { EpoxyPromoBanner } from "@/components/garage/EpoxyPromoBanner";
import { Partners } from "@/components/garage/Partners";
import { Comparison } from "@/components/garage/Comparison";
import { ClientForLife } from "@/components/garage/ClientForLife";
import { EcoCommitment } from "@/components/garage/EcoCommitment";
import { About } from "@/components/garage/About";
import { Footer } from "@/components/garage/Footer";
import { FloatingCTA } from "@/components/garage/FloatingCTA";

// Heavy below-the-fold components — code-split to shrink initial JS
const ServiceArea = lazy(() =>
  import("@/components/garage/ServiceArea").then((m) => ({ default: m.ServiceArea }))
);
const Booking = lazy(() =>
  import("@/components/garage/Booking").then((m) => ({ default: m.Booking }))
);

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <EpoxyPromoBanner />
        <HowItWorks />
        <Comparison />
        <LaunchOffer />
        <Services />
        <ClientForLife />
        <EcoCommitment />
        <Partners />
        <Suspense fallback={<div className="min-h-[400px]" />}>
          <ServiceArea />
        </Suspense>
        <About />
        <Suspense fallback={<div className="min-h-[400px]" />}>
          <Booking />
        </Suspense>
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
};

export default Index;
